import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RestService } from './rest.service';
import { FirebaseService } from './firebase.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // store the URL so we can redirect after logging in
  constructor(private restService: RestService, private firebase: FirebaseService) {
  }
  checkAuth(): Observable<any> {
    return this.restService.getMethod(this.restService.urls.checkAuth);

  }
  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }
  async login(fbToken: string) {
    await this.firebase.authenticateFirebase(fbToken)
    this.loggedIn.next(true);
  }
  clearLogin() {
    //sessionStorage.removeItem('AUTH');
    this.loggedIn.next(false);
  }
  logout(): void {
    //TODO: firebase implementation
    this.clearLogin()
    this.firebase.signOut();
    window.location.reload();
  }
}
